/* eslint-disable @angular-eslint/component-selector */

import { Component, Input, OnInit } from '@angular/core';
import { Audit } from 'app/core/models/audit.model';
import { obj2Html } from '../../../core/lib/js-utils';
import { AuditOfficeActionMetaComponent } from '../audit-office-action-meta/audit-office-action-meta.component';
import { DatePipe } from '@angular/common';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: '[app-audit-office-create-row]',
    templateUrl: './audit-office-create-row.component.html',
    styleUrls: ['./audit-office-create-row.component.scss'],
    imports: [AuditOfficeActionMetaComponent, DatePipe, BlankValueDashPipe]
})
export class AuditOfficeCreateRowComponent implements OnInit {
  @Input() audit: Audit;
  newValueHtml;

  constructor() {}

  ngOnInit() {
    const {
      internalNotes, // eslint-disable-line unused-imports/no-unused-vars
      ...changes
    } = this.audit.auditedChanges;

    this.newValueHtml = obj2Html(changes);
  }
}
